<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
			height="60vh"
			@selection-change="handleSelectionChange"
		>
			<el-table-column type="selection" width="55"> </el-table-column>

			<el-table-column prop="name" label="类目名称" width="120">
			</el-table-column
			><el-table-column prop="to_special.name" label="所属专区名称" width="120">
			</el-table-column>
			<el-table-column prop="desc" label="描述" show-overflow-tooltip>
			</el-table-column>

			<el-table-column
				prop="create_time"
				label="创建时间"
				show-overflow-tooltip
			>
			</el-table-column>

			<el-table-column fixed="right" label="操作" width="190">
				<template slot-scope="scope">
					<span class="pointer margin_left_10" @click="toEdit(scope.row)"
						>编辑</span
					>
					<span class="pointer margin_left_10" @click="toDelete(scope.row)"
						>删除</span
					>
				</template>
			</el-table-column>
		</el-table>
		<addForm
			ref="editForm"
			:title="title"
			type="edit"
			:tableData="tableData"
		></addForm>
	</div>
</template>

<script>
import addForm from "./addForm.vue";

import { destroyspecial } from "@/api/article";

export default {
	props: ["tableData"],
	components: { addForm },
	name: "",
	data() {
		return {
			value: true,
			title: "",
		};
	},
	methods: {
		toEdit(row) {
			this.$refs.editForm.dialog = true;
			this.title = "编辑专题";
			row.is_selected = row.is_selected
				? row.is_selected.toString()
				: row.is_selected;
			row.language = row.language ? row.language.toString() : row.language;
			for (let key in row) {
				this.$refs.editForm.formData[key] = row[key];
			}
			this.$refs.editForm.type = "edit";
		},
		toDelete(row) {
			this.$confirm("此操作将删除该条专题, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					destroyspecial({ id: row.id }).then((res) => {
						if (res.code == 200) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.$parent.$parent.getDataList();
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
	},
};
</script>

<style scoped></style>
